<template>
    <div id="moregames">
        <!-- -------------------------更多遊戲switch開始------------------------- -->
        <section class="cm-gamemore-switch">
            <a class="cm-gamemore-close" @click="show('MOREGAMECLOSE')">
                <img src="@/assets/images/moregame-close.png">
            </a>
            <div class="cm-gamemore-banner-line"></div>
            <a class="cm-gamemore-open" @click="show('MOREGAMEOPEN')">
                <img src="@/assets/images/moregame.png">
            </a>
        </section>
        <!-- -------------------------更多遊戲switch結束------------------------- -->
    </div>
</template>

<script>
import $ from "jquery";
import { cm_title_container_dynamic_height } from "@/assets/js/cm-game";

export default {
    name: "moregames",
    methods: {
        show(event) {
            switch (event) {
                case "MOREGAMEOPEN":
                    $(".cm-gamemore-close").hide();
                    $(".cm-game-showmoregame").slideToggle("0.5"); //JQ 的功能： 可以拉上拉下開啟DIV
                    $(".cm-gamemore-close").show();
                    $(".cm-gamemore-open").hide();
                    // 首頁頁面中遊戲介紹的圖片title動態調整高度
                    if(typeof cm_title_container_dynamic_height != "undefined") {
                        cm_title_container_dynamic_height();
                    }
                    break;
                case "MOREGAMECLOSE":
                    $(".cm-game-showmoregame").slideToggle("0.5"); //JQ 的功能： 可以拉上拉下開啟DIV
                    $(".cm-gamemore-close").hide();
                    $(".cm-gamemore-open").show();
                    break;
            }
        }
    }
};
</script>